import { useSelector } from "react-redux";
import { useNavigate, generatePath, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import useGetClientId from "../hooks/useGetClientId";
import LoadingComponent from "./common/LoadingComponent";

export default function RoleBasedRoute({ allowedRoles, children }) {
  const { userObj } = useSelector((state) => state.user);
  const clientObj = useGetClientId();
  const navigate = useNavigate();
  const { clientNameParam } = useParams();
  const [ready, setReady] = useState(false);
  const [accessCheckDone, setAccessCheckDone] = useState(false);
  const [accessDenied, setAccessDenied] = useState(false);

  useEffect(() => {
    if (!userObj || !clientObj) {
      navigate("/client");
    }
  }, [userObj, clientObj, navigate]);

  useEffect(() => {
    const t = setTimeout(() => setReady(true), 600);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    if (!ready || !userObj || !clientObj) return;

    const roleId = Number(clientObj?.roleId);
    const isAllowed = allowedRoles.includes(roleId);

    if (!isAllowed) {
      setAccessCheckDone(false);
      setAccessDenied(false);
      const timer = setTimeout(() => {
        setAccessCheckDone(true);
        setAccessDenied(true);
      }, 800);
      return () => clearTimeout(timer);
    } else {
      setAccessDenied(false);
      setAccessCheckDone(true);
    }
  }, [ready, userObj, clientObj, allowedRoles]);

  if (!ready || !userObj || !clientObj) {
    return <LoadingComponent loading={true} />;
  }

  if (accessDenied) {
    if (!accessCheckDone) {
      return <LoadingComponent loading={true} />;
    }

    return (
      <div className="d-flex flex-column justify-content-center align-items-center vh-100 text-center">
        <h2 className="text-danger fw-bold">Access Denied</h2>
        <p className="mt-3 fs-5">
          You do not have permission to access this page.
          <br />
          Please contact your administrator.
        </p>
        <button
          type="button"
          className="btn btn-primary mt-3"
          onClick={() =>
            navigate(
              generatePath("/client/:clientNameParam/property-form", {
                clientNameParam,
              })
            )
          }
        >
          Back to Home
        </button>
      </div>
    );
  }

  return children;
}
